import { useState } from "react";
import { ImageIcon, X } from "lucide-react";
import { BACKEND_URL } from "../../lib/api";
import { useGet } from "../../lib/hooks";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";

export function AssetPicker({ value, onChange, testid = "asset-picker" }) {
  const [open, setOpen] = useState(false);
  const [assets] = useGet(open ? "/asset-picker" : null, [open]);
  return (
    <div className="flex items-center gap-3">
      <div className="h-14 w-24 rounded-sm border bg-muted bg-cover bg-center grid place-items-center" style={value ? { backgroundImage: `url(${BACKEND_URL}${value})` } : {}}>
        {!value && <ImageIcon className="h-4 w-4 text-muted-foreground" />}
      </div>
      <Button type="button" size="sm" variant="secondary" onClick={() => setOpen(true)} data-testid={testid}>Choose from Media Library</Button>
      {value && <Button type="button" size="icon" variant="ghost" onClick={() => onChange("")} data-testid={`${testid}-clear`}><X className="h-4 w-4" /></Button>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl">
          <DialogHeader><DialogTitle className="font-display">Media Library</DialogTitle><DialogDescription>Pick an image. Upload new images in the Media Library.</DialogDescription></DialogHeader>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 max-h-[60vh] overflow-y-auto">
            {(assets || []).map((a) => (
              <button key={a.id} type="button" onClick={() => { onChange(a.url); setOpen(false); }} data-testid={`pick-asset-${a.id}`}
                className={`rounded-md border overflow-hidden text-left transition-colors hover:border-[#C2A462] ${value === a.url ? "border-[#C2A462]" : ""}`}>
                <div className="h-24 bg-cover bg-center" style={{ backgroundImage: `url(${BACKEND_URL}${a.url})` }} />
                <div className="p-2 text-xs truncate">{a.name}<span className="ml-1 text-muted-foreground">· {a.scope}</span></div>
              </button>
            ))}
            {assets && !assets.length && <div className="text-sm text-muted-foreground">No images yet.</div>}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
